import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's CSS theme
import './Styles.css';

const Editor = ({ textState, onTextChange }) => {
  return (
    <div style={{ width: "100%" }}>
      <ReactQuill
        value={textState}
        onChange={onTextChange}
        theme="snow" // Snow is the default theme
        style={{ width: "100%"}}
        modules={{
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'align': [false, 'center', 'right', 'justify'] }],
            ['link'],
            ['clean']
          ]
        }}
      
      />
    </div>
  );
};

export default Editor;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/Editor.js